import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-ghost-card',
  templateUrl: './table-ghost-card.component.html',
  styleUrls: ['./table-ghost-card.component.scss']
})
export class TableGhostCardComponent implements OnInit {

  tableData: any[][] = [];
  @Input() headers: any[];
  constructor() { }

  ngOnChanges(){
    this.generateTableData();
  }

  ngOnInit() {
  
  }

  generateTableData() {
    for (let i = 0; i < 8; i++) {
      const rowData = [];
      for (let j = 0; j < this.headers.length; j++) {
        const width =  Math.floor(Math.random() * 51) + 50; // Random width between 4 and 6
        rowData.push({ width: width });
      }
      this.tableData.push(rowData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-ghost-card-module/table-ghost-card/table-ghost-card.component.ts